((root) => {
  const resolve = (pickup, accessories = [], quantity = 1) => {
    const count = Number(quantity);
    const variants = [pickup, ...accessories];
    const valid = Number.isSafeInteger(count) && count > 0 && variants.every((variant) => {
      const price = variant?.priceCents ?? variant?.price;
      return variant && /^[1-9]\d*$/.test(String(variant.id)) && Number.isSafeInteger(price) && price >= 0;
    });
    if (!valid) return { valid: false, available: false, quantity: count, totalCents: 0, items: [] };
    return {
      valid: true,
      available: variants.every((variant) => variant.available === true),
      quantity: count,
      totalCents: variants.reduce((sum, variant) => sum + (variant.priceCents ?? variant.price), 0) * count,
      items: variants.map((variant) => ({ id: variant.id, quantity: count }))
    };
  };
  root.NeuraCoilBuild = Object.freeze({ resolve });
})(globalThis);
